import {LoginResultRecord} from "@commons/mapping/LoginResultRecord";
import Axios from "axios";
import {config} from "@commons/config.instance";

export function validateToken(url: string, token: string): Promise<LoginResultRecord> {

    const api = `${url}/${token}`;

    return Axios.get<LoginResultRecord>(api, {})
        .then(res => {
            return res.data;
        }, res => {
            //removeItemLocalStorage('token');
            return res.data ? res.data : {} as LoginResultRecord;
        })
}

export function validateDefaultToken(token: string): Promise<LoginResultRecord> {
    return validateToken(config.getBaseUrl('HR') + '/access/login', token);
}